import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UsersSvg = function UsersSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.222 4a3.9 3.9 0 0 0-2.815 1.214 4.23 4.23 0 0 0-1.166 2.93c0 1.1.42 2.154 1.166 2.931a3.9 3.9 0 0 0 2.815 1.214 3.9 3.9 0 0 0 2.816-1.214 4.23 4.23 0 0 0 1.166-2.93c0-1.1-.42-2.154-1.167-2.931A3.9 3.9 0 0 0 9.223 4M7.454 6.304a2.45 2.45 0 0 1 1.768-.762c.663 0 1.3.274 1.768.762.469.488.732 1.15.732 1.84s-.263 1.353-.732 1.84a2.45 2.45 0 0 1-1.768.763 2.45 2.45 0 0 1-1.768-.762 2.66 2.66 0 0 1-.732-1.84c0-.69.264-1.353.732-1.84",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.593 5.214A3.9 3.9 0 0 0 14.778 4v1.542c.663 0 1.299.274 1.768.762.468.488.732 1.15.732 1.84s-.264 1.353-.732 1.84a2.45 2.45 0 0 1-1.768.763v1.542a3.9 3.9 0 0 0 2.815-1.214 4.23 4.23 0 0 0 1.166-2.93c0-1.1-.42-2.154-1.166-2.931"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.222 13.639c2.406-.004 4.77.654 6.853 1.908l.37.223V20H2v-4.23l.37-.223a13.24 13.24 0 0 1 6.852-1.908m5.74 3.03a11.8 11.8 0 0 0-5.739-1.488c-2.077 0-4.03.538-5.742 1.488v1.789h11.482z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.63 15.548a13.3 13.3 0 0 0-3.427-1.46l-.37 1.493c.934.25 1.836.616 2.686 1.088v1.789h-2.5V20H22v-4.23z"
  }));
};
export var Users = function Users(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UsersSvg
  }));
};